import { render, staticRenderFns } from "./cabinet-fl44-notice-card-block-info.vue?vue&type=template&id=457d4e49&"
import script from "./cabinet-fl44-notice-card-block-info.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-notice-card-block-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('457d4e49')) {
      api.createRecord('457d4e49', component.options)
    } else {
      api.reload('457d4e49', component.options)
    }
    module.hot.accept("./cabinet-fl44-notice-card-block-info.vue?vue&type=template&id=457d4e49&", function () {
      api.rerender('457d4e49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-block-info.vue"
export default component.exports